import { PlanBuildStage, buildPlanProgressContent } from '@/types/planBuildProgress';
import type { PlanBuildProgress } from '@/types/planBuildProgress';
import { PlanBuildProgressDebugOverlay } from './PlanBuildProgressDebugOverlay';
import { PlanProgressHeader } from './PlanProgressHeader';
import { PlanProgressStageRow } from './PlanProgressStageRow';

interface PlanBuildProgressCardProps {
  outboundProgress: PlanBuildProgress | null | undefined;
  className?: string;
}

/**
 * Renders signal-driven plan-build progress: header + stage rows.
 * No timers; state comes only from backend outboundProgress.
 */
export function PlanBuildProgressCard({
  outboundProgress,
  className,
}: PlanBuildProgressCardProps) {
  const { initialMessage, subMessage, stages } = buildPlanProgressContent(outboundProgress);
  const isGenerateStage =
    outboundProgress?.stage === PlanBuildStage.GENERATE_TRAINING_PLAN;

  return (
    <div
      className={className}
      role="region"
      aria-label="Plan build progress"
    >
      <div className="mb-3">
        <PlanProgressHeader
          message={subMessage ?? initialMessage}
          runnerFaster={isGenerateStage}
        />
      </div>
      <ul className="space-y-2" role="list">
        {stages.map((stage, index) => (
          <PlanProgressStageRow
            key={index}
            description={stage.description}
            state={stage.state}
          />
        ))}
      </ul>
      {outboundProgress && (
        <PlanBuildProgressDebugOverlay
          outboundProgress={outboundProgress}
        />
      )}
    </div>
  );
}
